var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 168.48 168.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#17365f;filter:url(#drop-shadow-1);stroke-width:0px;}"), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#231f20",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.17,8.04C39.01,8.04,8.07,38.98,8.07,77.14s30.94,69.1,69.1,69.1,69.1-30.94,69.1-69.1S115.33,8.04,77.17,8.04ZM111.57,54.47l-34.02,52.77c-1.33,2.06-3.5,3.24-5.77,3.4-.52.11-1.04.17-1.57.17-1.85,0-3.69-.68-5.14-2.04l-24.25-22.86c-3.01-2.84-3.15-7.59-.31-10.6,2.84-3.01,7.59-3.15,10.6-.31l18.28,17.23,29.58-45.88c2.25-3.48,6.89-4.48,10.37-2.24,3.48,2.24,4.48,6.89,2.24,10.37Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedCheck);
export default __webpack_public_path__ + "static/media/selected-check.23e565824733291c73e45d2e7a69be40.svg";
export { ForwardRef as ReactComponent };